import { ReactElement, useRef, useState } from 'react';
import { Button, Heading, Input } from '@appsumo/dorado-react';

import { Loader } from '~/components/ui';
import { useGiftCardSubmission } from '~/hooks/account';

export default function AccountGiftCards(): ReactElement {
  const codeRef = useRef<HTMLInputElement>(null);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const { codeError, clearCodeError, pendingSubmit, submitGiftCard } =
    useGiftCardSubmission();

  return (
    <div className="flex flex-col gap-y-2">
      <Heading.H3>Gift cards</Heading.H3>
      <p>
        Paste your redemption code in the field below. The gift card amount will
        be added to your account&apos;s credit balance.
      </p>

      <label
        htmlFor="code"
        className="mt-2 block font-header font-semibold text-midnight"
      >
        Redemption code
      </label>
      <div className="flex w-full flex-col md:flex-row">
        <div className="inline-block flex-1">
          <Input
            data-testid="gift-card-input"
            ref={codeRef}
            type="text"
            name="code"
            error={codeError}
            onChange={() => {
              const hasCode = !!codeRef?.current?.value;
              setDisabledBtn(!hasCode);
              if (!hasCode) clearCodeError();
            }}
          />
        </div>
        <Button
          data-testid="gift-card-button"
          type="button"
          className="mt-2 inline-flex h-fit w-full justify-center md:ml-4 md:mt-0 md:w-fit"
          onClick={async () => {
            setDisabledBtn(true);
            const success = await submitGiftCard(
              codeRef.current?.value as string,
            );
            if (success && codeRef?.current?.value) {
              codeRef.current.value = '';
            }
          }}
          disabled={pendingSubmit || disabledBtn}
        >
          <span>Redeem</span>
          {pendingSubmit && (
            <span>
              <Loader size="sm" className="ml-2" />
            </span>
          )}
        </Button>
      </div>
    </div>
  );
}
